import React from "react";
import {
  Box,
  MenuItem,
  Select,
  Typography,
  SvgIcon,
  SelectChangeEvent,
} from "@mui/material";
import { appointmentDropDownStyles } from "./AppointmentDropDownStyles";

interface DropdownIconProps extends React.ComponentProps<typeof SvgIcon> {
  disabled: boolean;
}

const CustomDropdownIcon = ({ disabled, ...rest }: DropdownIconProps) => (
  <SvgIcon
    {...rest}
    sx={{
      fontSize: 24,
      color: disabled ? "#E5E5E5" : "#000",
      pointerEvents: "none", // Allow click to reach Select root
    }}
  >
    <path
      d="M7 10l5 5 5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);

interface AppointmentDropdownProps {
  options: { value: string; label: string }[];
  selected: string;
  setSelected: (value: string) => void;
}
export const AppointmentDropdown = ({
  options,
  selected,
  setSelected,
}: AppointmentDropdownProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedOption = options.find(
      (option) => option.value === event.target.value
    );
    if (selectedOption) {
      setSelected(selectedOption.value);
    }
  };
  const isDisabled = options.length < 2;
  return (
    <Box sx={appointmentDropDownStyles.wrapper}>
      <Typography sx={appointmentDropDownStyles.title}>
        Select Appointment
      </Typography>

      <Select
        disabled={isDisabled}
        value={selected}
        onChange={handleChange}
        variant="standard"
        IconComponent={(iconProps) => (
          <CustomDropdownIcon {...iconProps} disabled={isDisabled} />
        )}
        disableUnderline={false}
        sx={appointmentDropDownStyles.select}
        MenuProps={appointmentDropDownStyles.menuProps}
      >
        {options.map((option: { value: string; label: string }) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={appointmentDropDownStyles.menuItem}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
